module.exports = __webpack_public_path__ + "static/13-2d0ebc3fe7088dae3c7409bcf64cef4e.jpg";